/**
 * Copyright (c) 2020 Yusaku Nishiwaki
 * this extension uses tracking.js (https://github.com/eduardolundgren/tracking.js)
 */

const BlockType = require("../../extension-support/block-type");
const ArgumentType = require("../../extension-support/argument-type");
const Cast = require("../../util/cast");
const log = require("../../util/log");
const formatMessage = require("format-message");
require("./tracking");

const iconURI =
    "data:image/svg+xml;base64,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";
const menuIconURI =
    "data:image/svg+xml;base64,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";

const AvailableLocales = ["en", "ja", "ja-Hira"];

const Message = {
    categoryName: {
        ja: "色を追いかける",
        "ja-Hira": "いろをおいかける",
        en: "color tracking",
    },
    start: {
        ja: "スタート",
        "ja-Hira": "スタート",
        en: "start",
    },
    stop: {
        ja: "ストップ",
        "ja-Hira": "ストップ",
        en: "stop",
    },
    getredX: {
        ja: "赤 x座標",
        "ja-Hira": "あか xざひょう",
        en: "red x position",
    },
    getredY: {
        ja: "赤 y座標",
        "ja-Hira": "あか yざひょう",
        en: "red y position",
    },
    getgreenX: {
        ja: "緑 x座標",
        "ja-Hira": "みどり xざひょう",
        en: "green x position",
    },
    getgreenY: {
        ja: "緑 y座標",
        "ja-Hira": "みどり yざひょう",
        en: "green y position",
    },
    getblueX: {
        ja: "青 x座標",
        "ja-Hira": "あお xざひょう",
        en: "blue x position",
    },
    getblueY: {
        ja: "青 y座標",
        "ja-Hira": "あお yざひょう",
        en: "blue y position",
    },
    getYelloX: {
        ja: "黄色 x座標",
        "ja-Hira": "きいろ xざひょう",
        en: "yello x position",
    },
    getYelloY: {
        ja: "黄色 y座標",
        "ja-Hira": "きいろ yざひょう",
        en: "Yello y position",
    },
    switchCamera: {
        ja: "カメラを[camera]に切り替える",
        "ja-Hira": "カメラを[camera]にきりかえる",
        en: "switch to [camera]",
    },
    mirrorCamera: {
        ja: "カメラの向きを反転させる",
        "ja-Hira": "カメラのむきをはんたいにする",
        en: "mirror camera",
    },
    alreadyTracking: {
        ja: "既にスタートしています。",
        "ja-Hira": "もうスタートしているよ。",
        en: "Color tracking already started.i",
    },
    yetNotTracking: {
        ja: "先にスタートをしてください。",
        "ja-Hira": "まだスタートしていません。",
        en: "Please start tracking first.",
    },
    pleaseReload: {
        ja: "カメラを許可した直後はカメラを正常に読み込めません。ビジュアルプログラミングを再読み込みしてください。",
        "ja-Hira": "カメラを許可した直後はカメラを正常に読み込めません。ビジュアルプログラミングを再読み込みしてください。",
        en: "After just allowed camera, this extension do not work correctly. Please reload this page.",
    }
};

class kurikitTracking {
    constructor(runtime) {
        this._runtime = runtime;

        // video
        this._devices = new Array();
        this._id = 0;
        this._isMirror = false;

        // get Cameras
        var iter = 0;
        var that = this;
        navigator.mediaDevices
            .enumerateDevices()
            .then(function (devices) {
                devices.forEach(function (device) {
                    if (device.kind === "videoinput") {
                        that._devices.push({
                            text: device.label,
                            value: `${iter++}`,
                            id: device.deviceId,
                        });
                    }
                });
            })
            .catch(function (err) {
                console.log(err.name + ": " + err.message);
            })
            .then(() => {
                that._startCapture(0);
            })
            .catch(function (err) {
                console.log(err.name + ": " + err.message);
            });

        this.video = document.createElement("video");
        this.video.width = 480;
        this.video.height = 360;
        this.video.autoplay = true;
        this.video.style.display = "none";

        // tracking
        this._isTracking = false;
        this.threshold = 50;
        this.tracker = null;
        this._green_x = -1;
        this._green_y = -1;
        this._red_x = -1;
        this._red_y = -1;
        this._blue_x = -1;
        this._blue_y = -1;
        this._yellow_x = -1;
        this._yellow_y = -1;
    }

    _startCapture(id) {
        let media = navigator.mediaDevices.getUserMedia(
            this._getVideoConfig(id)
        );
        media.then((stream) => {
            this.video.srcObject = stream;
        });
        this._runtime.ioDevices.video.enableVideo(this._devices[id].id);
        this._runtime.ioDevices.video.mirror = this._isMirror;
    }

    _getVideoConfig(id) {
        return {
            audio: false,
            video: {
                width: { ideal: 480, max: 480 },
                height: { ideal: 360, max: 360 },
                frameRate: { ideal: 5, max: 5 },
                deviceId: { exact: this._devices[id].id },
            },
        };
    }

    _stopCapture() {
        if (this.video.srcObject == null) return;
        this._runtime.ioDevices.video.disableVideo();
        this.video.srcObject.getTracks().forEach((t) => {
            t.stop();
        });
        this.video.srcObject = null;
    }

    getInfo() {
        return {
            id: "kurikitTracking",
            name: Message.categoryName[this.setLocale()],
            menuIconURI: menuIconURI,
            blockIconURI: iconURI,

            blocks: [
                {
                    opcode: "start",
                    blockType: BlockType.COMMAND,
                    text: Message.start[this.setLocale()],
                },
                {
                    opcode: "stop",
                    blockType: BlockType.COMMAND,
                    text: Message.stop[this.setLocale()],
                },
                {
                    opcode: "getredX",
                    blockType: BlockType.REPORTER,
                    text: Message.getredX[this.setLocale()],
                },
                {
                    opcode: "getredY",
                    blockType: BlockType.REPORTER,
                    text: Message.getredY[this.setLocale()],
                },
                {
                    opcode: "getgreenX",
                    blockType: BlockType.REPORTER,
                    text: Message.getgreenX[this.setLocale()],
                },
                {
                    opcode: "getgreenY",
                    blockType: BlockType.REPORTER,
                    text: Message.getgreenY[this.setLocale()],
                },
                {
                    opcode: "getblueX",
                    blockType: BlockType.REPORTER,
                    text: Message.getblueX[this.setLocale()],
                },
                {
                    opcode: "getblueY",
                    blockType: BlockType.REPORTER,
                    text: Message.getblueY[this.setLocale()],
                },
                {
                    opcode: "getYelloX",
                    blockType: BlockType.REPORTER,
                    text: Message.getYelloX[this.setLocale()],
                },
                {
                    opcode: "getYelloY",
                    blockType: BlockType.REPORTER,
                    text: Message.getYelloY[this.setLocale()],
                },
                {
                    opcode: "switchCamera",
                    blockType: BlockType.COMMAND,
                    text: Message.switchCamera[this.setLocale()],
                    arguments: {
                        camera: {
                            type: ArgumentType.NUMBER,
                            menu: "cameras",
                            defaultValue: 0,
                        },
                    },
                },
                {
                    opcode: "mirrorCamera",
                    blockType: BlockType.COMMAND,
                    text: Message.mirrorCamera[this.setLocale()],
                },
            ],

            menus: {
                cameras: {
                    items: "_getCameraMenu",
                },
            },
        };
    }

    _getCameraMenu() {
        if (this._devices.length === 0) {
            return [
                {
                    text: "none",
                    value: "0",
                },
            ];
        } else {
            return this._devices;
        }
    }

    getColorDistance(target, actual) {
        return Math.sqrt(
            (target.r - actual.r) * (target.r - actual.r) +
                (target.g - actual.g) * (target.g - actual.g) +
                (target.b - actual.b) * (target.b - actual.b)
        );
    }

    start() {
        if (this._isTracking) {
            alert(Message.alreadyTracking[this.setLocale()]);
            return;
        }

        log.log("start");
        window.tracking.ColorTracker.registerColor("red", (r, g, b) => {
            return (
                this.getColorDistance(
                    { r: 240, g: 50, b: 50 },
                    { r: r, g: g, b: b }
                ) < this.threshold
            );
        });
        window.tracking.ColorTracker.registerColor("green", (r, g, b) => {
            return (
                this.getColorDistance(
                    { r: 0, g: 150, b: 150 },
                    { r: r, g: g, b: b }
                ) <
                this.threshold + 20
            );
        });
        window.tracking.ColorTracker.registerColor("blue", (r, g, b) => {
            return (
                this.getColorDistance(
                    { r: 50, g: 150, b: 230 },
                    { r: r, g: g, b: b }
                ) < this.threshold
            );
        });
        this.tracker = new window.tracking.ColorTracker([
            "red",
            "green",
            "blue",
            "yellow",
        ]);
        window.tracking.track(this.video, this.tracker);

        var that = this;
        this.tracker.on("track", (event) => {
            if (event.data.length === 0) {
                // No colors were detected in this frame.
            } else {
                event.data.forEach(function (rect) {
                    // rect.x, rect.y, rect.height, rect.width, rect.color
                    // log.log(rect.x, rect.y, rect.color);

                    if (rect.color == "red") {
                        that._red_x =
                            (rect.x - that.video.width / 2 + rect.width / 2) *
                            (that._isMirror ? -1 : 1);
                        that._red_y =
                            that.video.height / 2 - rect.y - rect.height / 2;
                    }
                    if (rect.color == "green") {
                        that._green_x =
                            (rect.x - that.video.width / 2 + rect.width / 2) *
                            (that._isMirror ? -1 : 1);
                        that._green_y =
                            that.video.height / 2 - rect.y - rect.height / 2;
                    }
                    if (rect.color == "blue") {
                        that._blue_x =
                            (rect.x - that.video.width / 2 + rect.width / 2) *
                            (that._isMirror ? -1 : 1);
                        that._blue_y =
                            that.video.height / 2 - rect.y - rect.height / 2;
                    }
                    if (rect.color == "yellow") {
                        that._yellow_x =
                            (rect.x - that.video.width / 2 + rect.width / 2) *
                            (that._isMirror ? -1 : 1);
                        that._yellow_y =
                            that.video.height / 2 - rect.y - rect.height / 2;
                    }
                });
            }
        });

        this._isTracking = true;
    }

    stop() {
        if (!this._isTracking) {
            alert(Message.yetNotTracking[this.setLocale()]);
            return;
        }

        log.log("stop");
        this.tracker.removeAllListeners();

        this._isTracking = false;
    }

    getredX() {
        return this._red_x;
    }

    getredY() {
        return this._red_y;
    }

    getgreenX() {
        return this._green_x;
    }

    getgreenY() {
        return this._green_y;
    }

    getblueX() {
        return this._blue_x;
    }

    getblueY() {
        return this._blue_y;
    }

    getYelloX() {
        return this._yellow_x;
    }

    getYelloY() {
        return this._yellow_y;
    }

    switchCamera(args) {
        if (this._devices[0].id === "") {
            alert(Message.pleaseReload[this.setLocale()]);
            return;
        }

        this._stopCapture();
        new Promise((resolve) => {
            setTimeout(() => {
                resolve();
            }, 1000);
        }).then(() => {
            this._startCapture(Cast.toNumber(args.camera));
        });
    }

    mirrorCamera() {
        this._isMirror = !this._isMirror;
        this._runtime.ioDevices.video.mirror = this._isMirror;
    }

    /////
    // private Functions
    /////
    setLocale() {
        let locale = formatMessage.setup().locale;
        if (AvailableLocales.includes(locale)) {
            return locale;
        } else {
            return "en";
        }
    }
}

module.exports = kurikitTracking;
